import React, { useEffect } from 'react';
import { getText } from '@storebrand-digital/fms-translations';

import { useFormik } from 'formik';
import { filterActions } from './reducer';
import { useContractNumbers } from './hooks';
import { useAppDispatch, useAppSelector } from '../../app/store';
import { selectFilters } from './selectors';
import DropdownFilter from '../../components/DropdownFilter';

function FilterFormContractNumbers() {
  const dispatch = useAppDispatch();
  const filters = useAppSelector(selectFilters);
  const { data: contractNumbers, status } = useContractNumbers();
  const formik = useFormik({
    initialValues: {
      contractNumbers: filters.contractNumbers ?? [],
    },
    enableReinitialize: true,
    onSubmit: () => {},
  });

  useEffect(() => {
    const selectedContractNumbers = formik.values.contractNumbers ?? [];
    dispatch(filterActions.changeContractNumbers(selectedContractNumbers));
  }, [formik.values.contractNumbers, dispatch]);

  const handleSelectionChange = (selectedValues: (string | number)[]) => {
    formik.setFieldValue('contractNumbers', selectedValues);
  };

  const handleClear = () => {
    formik.setFieldValue('contractNumbers', []);
  };

  const transformContractNumbersToOptions = () => {
    return (
      contractNumbers?.map((contractNumber) => ({
        label: contractNumber || '(blank)',
        value: contractNumber,
      })) ?? []
    );
  };

  const isLoading = status === 'pending';
  const hasError = status === 'error';
  const filterTitle = getText('filter.contract.title');

  return (
    <DropdownFilter
      name="contractNumbers"
      heading={filterTitle}
      title={filterTitle}
      options={transformContractNumbersToOptions()}
      selectedValues={formik.values.contractNumbers}
      onSelectionChange={handleSelectionChange}
      onClear={handleClear}
      loading={isLoading}
      error={hasError ? getText('filter.contract.fetchError') : undefined}
      trackId="button-dropdownfilter_agreement_number|Velg avtalenummer"
    />
  );
}

export default FilterFormContractNumbers;
